import { render, staticRenderFns } from "./MarketingPage.vue?vue&type=template&id=ef2c2a26&"
import script from "./MarketingPage.vue?vue&type=script&lang=js&"
export * from "./MarketingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports